<app-modal #modal [width]="width" [title]="title">
    <div class="mb-4" [ngClass]="payment ? 'text-sm' : 'text-lg'">{{ text }}</div>
    <ng-content></ng-content>
    <div class="flex justify-end">
        <app-button (click)="cancel()" [status]="'cancel'" variant="outline" class="mr-6">{{ cancelText }}</app-button>
        <app-button (click)="confirm()" variant="outline">{{ submitText }}</app-button>
    </div>
</app-modal>
